var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "flex-row",
      class: [
        _vm.isError ? "status-tag status-tag--error" : "status-tag",
        _vm.disableTip
          ? "status-tag--regular-cursor"
          : "status-tag--help-cursor",
      ],
      staticStyle: {
        padding: "2px 0",
        display: "flex",
        "align-items": "center",
      },
    },
    [
      _c("div", { staticClass: "status-indicator" }),
      _vm._v(" "),
      _c(
        "el-popover",
        {
          attrs: {
            disabled: _vm.disableTip,
            placement: "right",
            trigger: "hover",
          },
        },
        [
          _c(
            "span",
            {
              staticStyle: { "vertical-align": "middle" },
              attrs: { slot: "reference" },
              slot: "reference",
            },
            [_vm._v(_vm._s(_vm.statusMessage))]
          ),
          _vm._v(" "),
          _vm._t("popover-content"),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }